import { Bedrag, Knop } from '@qc/ui';
import type { EvenementBeeld } from './useEvenement.js';

export interface IngrijpenProps {
  beeld: EvenementBeeld;
}

/**
 * Ingrijpen tijdens het evenement. Een product blokkeren komt meteen in de
 * kassa terecht: de tegel gaat op uitverkocht en de kraam kan het niet meer
 * aanslaan.
 */
export function Ingrijpen({ beeld }: IngrijpenProps) {
  if (beeld.producten.length === 0) {
    return (
      <p className="text-tekst-zacht">
        Er staat nog geen goedgekeurd menu. Zodra dat er is, kun je hier producten blokkeren.
      </p>
    );
  }

  return (
    <div>
      <h2 className="mb-2 text-xl font-bold">Product blokkeren</h2>
      <p className="mb-4 text-tekst-zacht">
        Een geblokkeerd product staat bij de kraam op uitverkocht en kan niet meer worden
        aangeslagen. De kraam kan het zelf weer aanzetten zodra het weer klopt.
      </p>
      <ul className="grid gap-2">
        {beeld.producten.map((product) => {
          const geblokkeerd = beeld.uitverkocht.has(product.id);
          return (
            <li
              key={product.id}
              className="flex items-center justify-between gap-4 rounded-tegel border border-rand bg-vlak p-4"
            >
              <span className="min-w-0">
                <span className="block truncate text-lg">{product.naam}</span>
                <span className="block text-base text-tekst-zacht">
                  {product.categorie}
                  {geblokkeerd ? ' · staat op uitverkocht' : ''}
                </span>
              </span>
              <span className="flex shrink-0 items-center gap-4">
                <Bedrag centen={product.prijs_cent} className="text-lg" />
                <Knop
                  nadruk={geblokkeerd ? 'hoofd' : 'gevaar'}
                  className="px-4 text-base"
                  onClick={() => void beeld.blokkeerProduct(product.id, !geblokkeerd)}
                >
                  {geblokkeerd ? 'Vrijgeven' : 'Blokkeren'}
                </Knop>
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
